import universal from 'react-universal-component';

export default universal(() => import('./Logout'));



// WEBPACK FOOTER //
// ./src/app/views/Logout/index.js